
import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../images/logo.png';
import { COLORS } from '../Colors/Colors';
import { Link } from 'react-router-dom';
import '../css/Navigation.css';

const Navigation = () => {
  const handleNavLinkClick = () => {
    const navbarToggle = document.getElementById('navbar-toggle');
    const isMobile = window.innerWidth < 992; // Adjust breakpoint as needed

    if (navbarToggle && isMobile) {
      navbarToggle.click(); // Trigger the collapse only on mobile
    }
  };

  return (
    <Navbar expand="lg" sticky="top" collapseOnSelect style={{ background: `linear-gradient(45deg, ${COLORS.primary}, #862727)` }} variant="dark">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: 'white' }} onClick={handleNavLinkClick}>
          <img 
            src={logo} 
            alt="ITSMS Icon" 
            style={{ width: '50px', marginRight: '8px' }} 
          /> 
          KUSAVINI BALAGA
        </Navbar.Brand>
        <Navbar.Toggle id="navbar-toggle" aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
          <Nav.Link  className="nav-link-custom" as={Link} onClick={handleNavLinkClick} to="/">Home</Nav.Link>
            <Nav.Link className="nav-link-custom"   as={Link} onClick={handleNavLinkClick} to="/members">MEMBERS</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/membership-registration">MEMBERSHIP REGISTRATION</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/activities">ACTIVITIES</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/alumni">ALUMNI</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/gallery">GALLERY</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/donation">DONATION</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/students-corner">STUDENTS CORNER</Nav.Link>
            <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/contact-us">CONTACT US</Nav.Link>
            {/* <Nav.Link className="nav-link-custom"  as={Link} onClick={handleNavLinkClick} to="/about-us">ABOUT US</Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;

